module.exports = __webpack_public_path__ + "static/media/trending-up-outline.5f109536.svg";